var _clipPath, _clipPath2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1613.42,-4870.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue",
    transform: "matrix(0.991867,0,0,0.991867,1122.55,4870.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.892,
    y: 0,
    width: 403.28,
    height: 403.28,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.892,
    y: 0,
    width: 403.28,
    height: 403.28
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.00032,0,0,1.00032,494.827,-0.065533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.23,88.693C403.23,39.742 363.488,0 314.537,0L88.773,0C39.822,0 0.08,39.742 0.08,88.693L0.08,314.457C0.08,363.408 39.822,403.15 88.773,403.15L314.537,403.15C363.488,403.15 403.23,363.408 403.23,314.457L403.23,88.693Z",
    style: {
      fill: "rgb(50,0,229)"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.23,88.693C403.23,39.742 363.488,0 314.537,0L88.773,0C39.822,0 0.08,39.742 0.08,88.693L0.08,314.457C0.08,363.408 39.822,403.15 88.773,403.15L314.537,403.15C363.488,403.15 403.23,363.408 403.23,314.457L403.23,88.693Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.17145e-17,1.00787,-1.00787,6.17145e-17,5311.67,-1387.53)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1376.72,
    y: 4870.06,
    width: 400.015,
    height: 400.065,
    style: {
      fill: "url(#_Linear3)"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(313.837,0,0,313.837,583.076,322.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.438,0L0.124,0C0.107,-0 0.091,-0.007 0.079,-0.019C0.067,-0.031 0.06,-0.047 0.06,-0.064L0.06,-0.707C0.06,-0.742 0.089,-0.771 0.124,-0.771L0.536,-0.771C0.571,-0.771 0.6,-0.742 0.6,-0.707L0.6,-0.644C0.6,-0.633 0.597,-0.622 0.592,-0.612C0.575,-0.583 0.539,-0.52 0.539,-0.52C0.639,-0.48 0.708,-0.384 0.708,-0.27C0.708,-0.121 0.587,0 0.438,0Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(313.837,0,0,313.837,583.076,322.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.461,-0.383L0.331,-0.154L0.438,-0.154C0.502,-0.154 0.554,-0.206 0.554,-0.27C0.554,-0.326 0.514,-0.372 0.461,-0.383Z",
    style: {
      fill: "rgb(133,118,222)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(313.837,0,0,313.837,583.076,322.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.285,-0.385L0.214,-0.385L0.214,-0.26L0.285,-0.385Z",
    style: {
      fill: "rgb(133,118,222)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(313.837,0,0,313.837,583.076,322.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.224,-0.617C0.221,-0.617 0.219,-0.616 0.217,-0.614C0.215,-0.612 0.214,-0.61 0.214,-0.607L0.214,-0.54L0.373,-0.54L0.417,-0.617L0.224,-0.617Z",
    style: {
      fill: "rgb(133,118,222)"
    }
  }))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(400.015,0,0,400.065,1376.72,5070.09)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "white",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "black",
      stopOpacity: 0.21
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlue);
export default __webpack_public_path__ + "static/media/blue.fb422456b614ac039838a6847b7f8a97.svg";
export { ForwardRef as ReactComponent };